import apiClient from './apiClient';

const ctcService = {
  /**
   * Get all CTCs
   */
  getAll: async (page = 1, limit = 10, filters = {}) => {
    const params = new URLSearchParams({
      page,
      limit,
      ...filters
    });
    const response = await apiClient.get(`/ctcs?${params}`);
    return response.data;
  },

  /**
   * Get CTC by ID
   */
  getById: async (id) => {
    const response = await apiClient.get(`/ctcs/${id}`);
    return response.data;
  },

  /**
   * Create new CTC
   */
  create: async (ctcData) => {
    const response = await apiClient.post('/ctcs', ctcData);
    return response.data;
  },

  /**
   * Update CTC
   */
  update: async (id, ctcData) => {
    const response = await apiClient.put(`/ctcs/${id}`, ctcData);
    return response.data;
  },

  /**
   * Delete CTC
   */
  delete: async (id) => {
    const response = await apiClient.delete(`/ctcs/${id}`);
    return response.data;
  },

  /**
   * Get active CTC for employee
   */
  getActiveCTCForEmployee: async (employeeId) => {
    const response = await apiClient.get(`/ctcs/employee/${employeeId}/active`);
    return response.data;
  }
};

export default ctcService;
